export default __webpack_public_path__ + "static/curlnoiseparty-6ef6c3be403d457b2163f433945d988f.mp4";